import clsx from 'clsx';
import { useEffect, useRef, useState } from 'react';
import CheckboxField from '../CheckboxField';
import { setCurrency } from 'utils/functionality';
import { ReactComponent as Minus } from '../../../icons/minus-circle-filled-icon.svg';
import { ReactComponent as Plus } from '../../../icons/plus-circle-filled-icon.svg';

const SelectFieldAdditional = ({
  label,
  htmlFor,
  id,
  placeholder,
  data,
  // onChange,
  disable,
  className,
  style,
  ...rest
}) => {
  const dropdownRef = useRef(null);
  const [isShowDropdown, setIsShowDropdown] = useState(false);
  const [selectedAdditional, setSelectedAdditional] = useState({});

  useEffect(() => {
    // Add a click event listener to the document to handle clicks outside the dropdown.
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsShowDropdown(false);
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      // Remove the event listener when the component unmounts.
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsShowDropdown(!isShowDropdown);
  };

  const checkedAdditionalHandler = (e) => {
    const itemId = e.target.value;
    const selectedItem = data?.find((item) => item.id === itemId);

    setSelectedAdditional(selectedItem);
  };

  return (
    <div className={clsx(className, 'select-field-additional')} style={style} {...rest} ref={dropdownRef}>
      {label && (
        <label htmlFor={id ? id : htmlFor} className="select-field-additional__label">
          {label}
        </label>
      )}
      <div
        className={disable ? 'select-field-additional__input-field disable' : 'select-field-additional__input-field'}
        onClick={toggleDropdown}
      >
        <input
          id={id ? id : htmlFor}
          readOnly
          placeholder={placeholder}
          className="select-field-additional__input-field__input"
        />
      </div>

      {/* drop down */}
      {isShowDropdown && (
        <ul className="select-field-additional__dropdown">
          {data ? (
            data.map((item) => (
              <li key={item.id}>
                <CheckboxField
                  label={item.name}
                  value={item.id}
                  checked={item.id === selectedAdditional?.id}
                  readOnly={true}
                  id={item.id}
                  onChange={checkedAdditionalHandler}
                  variants="primary"
                />
                <div>{setCurrency(item.price)}</div>
                <div>
                  <Minus className="quantity-icon" />
                  <span>{item.value}</span>
                  <Plus className="quantity-icon" />
                </div>
              </li>
            ))
          ) : (
            <li>Data Not Found</li>
          )}
        </ul>
      )}
    </div>
  );
};

export default SelectFieldAdditional;
